//==================================================================
// Created by rmarquez   March/27/2018
// ThumbPageListUtil.js
// Utility methods for Thumb Page Lists
//==================================================================
import $ from 'jquery';
import _ from 'lodash';
import listService from 'ListService';
import { Model } from 'backbone';
import util from 'util/Util.js';
import objectBehaviorMap from 'ObjectBehaviorMapService';
import factoryService   from 'FactoryService';
import leftPanelState from "LeftPanelStateService";
import constants from 'Constants';
import Spinner from 'spin/spin';
import pageSyncService from 'PageSyncService';
import pageCaptureController from 'PageCaptureController';
import eventBus from 'EventBus';
import behaviorHelperService from 'BehaviorHelperService.js';


class ThumbPageListUtil {

    updatePageList(pageId, pageFactoryKey) {

        let fullNavigationHTML = "";
        // Page's behaviors
        let behaviors = this.getBehaviorsListForControl(pageFactoryKey, pageId);
        // and here the code to append them
        const newUlTree = $("#objects-page-" + pageId + " ul ");
      
        //Page objects
        const _objects = listService.getPageControls(pageId);
        let objectsHTML = "";

        if (_objects && _objects.size) {
            _objects.forEach((_object, idx) => {
                objectsHTML += this.addObjectToNavigationTree(_object, pageId);
            });
        }

        fullNavigationHTML = behaviors + objectsHTML;
        fullNavigationHTML = util.sanitizeHTML(fullNavigationHTML, false, '', false);

        listService.firstLoad = false;

        newUlTree.html(fullNavigationHTML);
    }

    updateBehaviorsOnly(pId) {

        const checkShowPage = (pageId) => {
            const objsPage = $("#objects-page-" + pageId);
            let active = objsPage.find(".active");

            return active && active.length > 0;
        };

        const checkShowControl = (object) => {

            const currentObj = $(object);
            const activeObj = currentObj.find(".active");            

            return activeObj && activeObj.length > 0;
        };

        const loadPage = (pageId) => {

            const objsPage = $("#objects-page-" + pageId);
            const boPage = $("#behaviors-only-page-" + pageId);
            const boList = boPage.find("ul");

            const tree = $("#objects-page-" + pageId + " ul");

            if(tree[0].childElementCount === 0){            
                this.loadTreeNodesByPageId(pageId);
            }

            if (checkShowPage(pageId)) { //If the page has at least one behavior

                boList.empty();
                let html = objsPage.html();
                html = html.replaceAll('objects-page-group-', 'bo-objects-page-group-');
                boPage.html(html);

                boPage.find(".object-selector").each((i, object) => {
                    if (!checkShowControl(object)) {
                        $(object).hide();
                    }
                });

                //Reattach events
                this.addSelectorEvents("#thumb-behaviorsOnly"); 
                
                //show the page
                $("#bo-pg-" + pageId).show();
            }
            else {
                $("#bo-pg-" + pageId).hide();
            }
        };

        const checkBehaviors = (objParent, behKey) => {
          

            let hasBehaviors = false;
            const behInstance = listService.getBehaviorInstanceByObjectAndBehaviorKey(objParent, behKey);

            if (behInstance && behInstance.id) {
                const dataId = behInstance.id;
                const objects = listService.getBehaviorInstanceObjects(dataId)

                if (objects && objects.size > 0) {
                    hasBehaviors = true;                    
                }
            }
            return hasBehaviors;
        }    
        
            //Page objects
            if (!pId || pId === "") {
                const pages = listService.pageList;
                pages.forEach((page) => {
                    loadPage(page.id);
                });
            }
            else {                
                const page = $("#objects-page-" + pId);
                let currentBehavior = page.find(".behavior-options.controlSelected");
                const data = currentBehavior.data();
                currentBehavior = currentBehavior.find("a");

                if (data) {
                    const objParent = data.objectid;
                    const behKey = data.behaviorkey;

                    const hasBehaviors = checkBehaviors(objParent, behKey);

                    if (hasBehaviors) {
                        currentBehavior.addClass("active");
                    }
                    else {
                        currentBehavior.removeClass("active");
                    }
                }
                
                if ($("#behaviorsonly-tab").hasClass("active")) {//Only load if the behaviors only tab is active

                    const visiblePages = $("#thumb-behaviorsOnly").find( ".pageContainer:visible" );

                    //IF there are no more visible pages go back to all objects tab
                    if(visiblePages.length === 0){
                        $("#allobjects-tab a").trigger("click");
                        return;
                    }
                    loadPage(pId);
                }
        }
           
    }

    addObjectToNavigationTree(object, pageId, forceAppend = false) {

        const objectModel = object.model || object;
        const objId = objectModel.get("id");
        const factoryKey = objectModel.get('factoryKey');
        const factoryName = factoryService.factories[factoryKey].name;
        const tooltipName = factoryName + ': ' + objectModel.get('name')
        const name = objectModel.get('name');
        const groupId = object.groupId;
        const childList = objectModel.get('childList');
        let children = "";

        //Check if object has children
        if(childList){
            childList.forEach((_object, idx) => {
                children += this.addObjectToNavigationTree(_object, pageId);
            });
        }

        let behaviors = this.getBehaviorsListForControl(factoryKey, objId);        
        let objectHTML = !groupId || forceAppend ? this.createElementHTML(objId, tooltipName, name, children, behaviors, pageId) : '';

        return objectHTML;

    }
    
    createElementHTML(objId, tooltipName, objectName, children, behaviors, pageId, behaviorsOnly){
        let groupStyle = children !== "" ? 'style="font-weight: bold; white-space: normal"' : 'style="white-space: normal"';
        let pageIdTag = "objects-page-" + pageId;
        let groupIdTag = "objects-page-group-" + objId;

        if(behaviorsOnly){
            pageIdTag = "behaviors-only-page-" + pageId;
            groupIdTag = "bo-objects-page-group-" + objId;
        }
        //Removes object in case it exists
        let objToRemove = $("#" + pageIdTag + ' ul li[data-id="' + objId + '"]');
        if (objToRemove && objToRemove.length) {
            $(objToRemove).remove();
        }

        //Add object behaviors
         let objectChildren =  `<div id="${groupIdTag}" class="bo-body collapse">
                                    <ul>
                                    ${ behaviors }
                                    ${ children }
                                    </ul>
                                </div>`

        let groupClass = "object-selector" + (children !== "" ? " active-behaviors" : "");

        return `<li data-id="${objId}" class="${groupClass}" ${groupStyle}>
                    <a class="switch" data-toggle="collapse" data-target="#${groupIdTag}"
                        title="${tooltipName}">
                        <i class="fa pf-carot-left pf-rotate-icon"></i>
                        <span class="control-name-selector">${objectName}</span>
                    </a>
                    ${objectChildren}
                </li>`;
    }   

    objectBehaviorsHTML(behavior){
             let beElement = `<li class="behavior-options behavior-selector" data-id="${behavior.id}"
                                data-behaviorkey="${behavior.behaviorKey}" data-objectid="${behavior.objectId}">
                                <a class="${behavior.active && behavior.active !== "" ? 'active' : ''}">
                                        <span class="control-name-selector">${behavior.text}</span></a></li>`;                
          return beElement;
    }

    checkBehaviors(){
        $('.controlSelected').removeClass('controlSelected');
        $(".behavior-selector").each((index, behavior)=>{
            const beh = $(behavior);
            const data = beh.data();
            const objParent = data.objectid;
            const behKey = data.behaviorkey;

            const instance = listService.getBehaviorInstanceByObjectAndBehaviorKey(objParent, behKey);
           
            let dataId = '';

            if(instance && instance.id){
                dataId = instance.id;
                const objects = listService.getBehaviorInstanceObjects(dataId)

                if (objects && objects.size > 0) {
                    beh.find("a").addClass("active");
                }
                else {
                    beh.find("a").removeClass("active");
                }
            }
            
            beh.data("id", dataId);
        });
    }
    
    moveElementToNewParent(controlId, newParentId, page){
        let targetUL;
        if (newParentId){
            targetUL = $("#objects-page-" + page + " ul li[data-id='" + newParentId + "'] > div > ul");
        }else{
            targetUL  = $("#objects-page-" + page + " > ul");
        }

        targetUL.append($("#objects-page-" + page + " ul li[data-id='" + controlId + "']"));
    }

    /*PF-4918. This is duplicated on PF-4918*/
    getBehaviorsListForControl(factoryKey, id, behaviorOnly) {
        let behaviors = objectBehaviorMap.getBehaviors(factoryKey);
        const self = this;   

        let behaviorHTML = "";
        let items = [];
        if (behaviors.length > 0 && ( listService.selectedCount === 0 || listService.selectedCount === 1 ) ) {
            _.forEach(behaviors, function(beh, idx) {
                let fixedId = id ==='aform' ? 'Form' : id;
                const instance = listService.getBehaviorInstanceByObjectAndBehaviorKey(fixedId, beh.behaviorKey);
                const object = instance && listService.getBehaviorInstanceObjects(instance.id);
                
                if (object && object.size > 0){
                    beh.active = true;

                    if(behaviorOnly){
                        behaviorOnly.hasActiveBehaviors = true;
                    }
                }
                else{
                    beh.active = false;
                }

                beh.id = instance ? instance.id : '';
                beh.objectId = fixedId
                behaviorHTML += self.objectBehaviorsHTML(beh);  
            });
        }
        else {
            items = undefined;
        }
        return behaviorHTML;
    }

    getBehaviorsListForFilter (factoryKey, id) {
        let behaviors = objectBehaviorMap.getBehaviors(factoryKey);
        let items = [];
        if (behaviors.length > 0 && ( listService.selectedCount === 0 || listService.selectedCount === 1 ) ) {
            _.forEach(behaviors, function(beh, idx) {
                items[idx] = {};
                let fixedId = id==='aform' ? 'Form' : id;
                const instance = listService.getBehaviorInstanceByObjectAndBehaviorKey(fixedId, beh.behaviorKey);
                const object = instance && listService.getBehaviorInstanceObjects(instance.id);
                if (object && object.size > 0){
                    items[idx].id = instance.id;
                    items[idx].behaviorKey = beh.behaviorKey;
                    items[idx].active = 'active';
                    items[idx].text = instance.get('text');
                    items[idx].mobileCompatible = beh.mobileCompatible;
                } else {
                    items[idx].id = '';
                    items[idx].active = '';
                    items[idx].behaviorKey = beh.behaviorKey;
                    items[idx].text = instance? instance.get('text') : beh.text;
                    items[idx].mobileCompatible = beh.mobileCompatible;
                }
                items[idx].objectId = fixedId;
            });
        }
        else {
            items = undefined;
        }
        return items;
    }

    expandControlParent(parent) {
        let parentId = parent.model.get('id');
        // If parent belongs to a group, expand the group first
        if (parent._groupId)  {
            let grandPa = listService.getObject(parent._groupId);
            this.expandControlParent(grandPa);
        }
        $('#objects-page-group-' + parentId).collapse('show');
        $('li[data-id="'+ parentId +'"]').addClass('controlSelected');
        const behaviorSwitch = $('li[data-id="'+parentId +'"] a i').first();
        behaviorSwitch.removeClass('pf-carot-left').removeClass('pf-rotate-icon')
                    .addClass('pf-carot-down').addClass('pf-no-rotate-icon');
    }

    applyFilterTreeStyles(id){
        $(`#filterResults ul.control-list.${id}.behavior-options-filter li a.active`).css({
            "padding-left": "0px",
            "color": "#db8e29",
            "font-weight": 500
        });

        $(`#filterResults ul.control-list.${id}.behavior-options-filter li a.active:before`).css({
            "content":'\uF013',
            "font-family":"FontAwesome",
            "padding-right": "5px"
        });

        $(`a#field-select-${id}`).css({
            'color':'black',
            'font-weight':'bold',
            'font-size':'11px'
        });
    }

    applyBehaviorFilterTreeStyles(){

        $(`#filterResults ul.control-list li.control-tree a`).css({
/*            'color':'black',
            'font-weight':'bold',
            'font-size':'11px'*/
        });

        $(`#filterResults ul.control-list li.behavior-tree a`).css({
            "padding-left": "0px",
            "color": "#db8e29",
            "font-weight": 500
        });

        $(`#filterResults ul.control-list li.command-tree a`).css({
            "padding-left": "0px",
            "color": "black",
            "font-weight": 'bolder'
        });
    }

    loadTreeNodesByPageId(pageId){
        const pageTreeItemDiv = $('#tn-pg-' + pageId)[0];
        if (pageTreeItemDiv && $(pageTreeItemDiv).find('li').length === 0){
            const page = listService.getPage(pageId);
            if (page){
                const pageFactoryKey = page.model.get('factoryKey');                    
                this.updatePageList(pageId, pageFactoryKey);
                leftPanelState.save();  
                this.addSelectorEvents(); 
            }
        }        
    }

    addSelectorEvents(container) {
        const self = this;
        let parentID = container || "#objects-tree";

        $(parentID).find('li.object-selector').off('click').on('click', (ev) => {
            ev.stopPropagation();
            let id = ev.currentTarget.attributes["data-id"].value;

            //If the user did not click the arrow only select the element
            if (!$(ev.target).hasClass('pf-carot-left') && !$(ev.target).hasClass('pf-carot-down')) {
                this.selectObject(id);
            }
            else{
                const target = $(ev.target.parentElement);
                const panel = $(target.data().target);
                const icon = $(ev.target);
                const collapsedIcon = 'pf-carot-left pf-rotate-icon';

                panel.collapse('toggle');
                util.togglePanel(target, icon, collapsedIcon);
            }
        });

        $(parentID).find('li.behavior-selector').off('click').on('click', (ev) => {
            ev.stopPropagation();
            leftPanelState.save();
            let id = ev.currentTarget.attributes["data-id"].value,
                objId = ev.currentTarget.attributes["data-objectid"].value,
                behaviorKey = ev.currentTarget.attributes["data-behaviorkey"].value;
            this.selectBehaviorInstance(id, '', objId, behaviorKey);
        });
    }

    selectBehaviorInstance(id, selectedCommand = '', objectId = '', behaviorKey = '') {

        let instance = listService.getBehaviorInstance(id);
        if (instance) {
            $('.controlSelected').removeClass('controlSelected');
            if (listService.mainKind === constants.KIND_BEHAVIORS) {
                eventBus.trigger('behaviorInstanceShow', id);                
                let $behaviorSelector = (instance.get('owner') === 'Form')
                    ? $('#behaviors-forms')
                    : $(`#behaviors-page-${listService.currentPageId}`);

                $behaviorSelector.find(`li[data-id="${id}"]`).addClass('controlSelected');
                behaviorHelperService.showBehaviorInstance(id);
            } else {
                let command = '';
                if (selectedCommand) {
                    command = '/' + selectedCommand;
                }

                // PF-1951 Turning on flag for back-button purposes
                listService.linkClicked = true;
                Backbone.history.loadUrl('behaviors/' + instance.get('ownerId') + '/' + instance.get('behaviorKey') + command);

            }

            const selectedObject = listService.getCanvasObjectById(selectedCommand);
            if (selectedObject) {
                selectedObject.hasBorders = true;
                listService.fcanvas.setActiveObject(selectedObject).renderAll();
                selectedObject.model.set('active', true);
                eventBus.trigger('selectSingleItemFromCanvas');
            } else {
                eventBus.trigger('showInstanceInformation', instance);
            }
        } else if (objectId) {
            let control = listService.getObject(objectId);
            if (!control) {
                control = listService.getPage(objectId);
            }

            listService.linkClicked = true;
            Backbone.history.loadUrl(`behaviors/${objectId}/${behaviorKey}`);
            listService.clearSelected();
        }
    }  
    
    selectObject(id) {
        leftPanelState.save();
        $('.controlSelected').removeClass('controlSelected');
        if (listService.mainKind === constants.KIND_LAYOUT || listService.mainKind === constants.KIND_REPORT) {
            this.changePageAndSelectObject(id, false);
        } else {
            listService.currentId = id;

            if (listService.docType === constants.DOC_TYPE_FORM) {
                // PF-1951 Turning on flag for back-button purposes
                listService.linkClicked = true;
                Backbone.history.loadUrl('edit');
                setTimeout(() => {
                    this.changePageAndSelectObject(id, true);
                }, 1000);
            } else {
                // PF-1951 Turning on flag for back-button purposes
                listService.linkClicked = true;
                Backbone.history.loadUrl('report');
                setTimeout(() => {
                    this.changePageAndSelectObject(id, true);
                }, 1000);
            }
        }
    }

    getViewValues(model) {
        const formBehaviorsObj = listService.getBehaviorFormTotals();

        return _.merge(model.toJSON(), {
            stages: listService.getWorkflowStages(true, true),
            roles: listService.getWorkflowRoles(true, true),
            currentRole: util.getCurrentRoleName(),
            currentStage: util.getCurrentStageName(),
            behaviors: formBehaviorsObj.behaviors,
            objects: listService.currentForm ? listService.currentForm.model.attributes.objects : [],
            behaviorCount: formBehaviorsObj.size,
            objectCount: listService.currentForm ? listService.currentForm.model.attributes.objectCount : 0
        });
    }

    changePageAndSelectObject(id, restoreLeftTree = false) {
        const currentPage = listService.currentPageId;
        const controlPage = listService.getObject(id);
        //if pages are different first move to the correct page and then select the control
        if (controlPage && controlPage.pageId !== currentPage) {
            const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
            window.setTimeout(() => {
                $('.pageSelected').removeClass('page-selected');
                $(`[data-page='${controlPage.pageId}']`).parent().closest('div').addClass('page-selected');
                pageSyncService.displayPage(controlPage.pageId);
                pageCaptureController.captureThumbnail();
                eventBus.trigger('selectForm');
                window.setTimeout(() => {
                    spinner.stop();
                }, 10);
            }, 10);
        }
        window.setTimeout(() => {
            let $element = $('#' + id + ' > div.pf-control-core');
            if (controlPage && controlPage.model.get('isGroupContainer')) {
                $element = $element.first();
            }
            if (controlPage && controlPage.pageId) {
                $('.page-selected').removeClass('page-selected');
                $(`[data-page='${controlPage.pageId}']`).parent().closest('div').addClass('page-selected');
                $(`#well${controlPage.pageId}`).collapse('show');
                listService.itemSearched = 0;
            }
            $element.trigger('click');
            if (restoreLeftTree) {
                window.setTimeout(() => {
                    leftPanelState.restore();
                }, 20);
            }
        }, 20);
    }

    loadBehaviorOnlyObject(_object, pageId, parentModel){
               
        let behaviorHTML = "", objectsHTML = "", children = "";
        const objectModel = _object.model || _object;
        const objId = objectModel.get("id");
        const factoryKey = objectModel.get('factoryKey');
        const factoryName = factoryService.factories[factoryKey].name;
        const tooltipName = factoryName + ': ' +  util.sanitizeHTML(objectModel.get('name'));
        const name = objectModel.get('name');
        const groupId = _object.groupId;
        const childList = objectModel.get('childList');
        
        _object.hasActiveBehaviors = false;
        //Check if object has children
        if (childList) {
            childList.forEach((obj, idx) => {
                children += this.loadBehaviorOnlyObject(obj, pageId, _object);

                if(obj.hasActiveBehaviors && parentModel){
                    _object.hasActiveBehaviors = true;
                }
            });
        }

        behaviorHTML = this.getBehaviorsListForControl(factoryKey, objId, _object);

        if (_object.hasActiveBehaviors){            
            objectsHTML += !groupId ? this.createElementHTML(objId, tooltipName, name, children, behaviorHTML, pageId, true) : '';
        }     

        return objectsHTML;
    }
    reorderByTabIndex(id, tabIndexDifference) {
        let list = $('#objects-page-' + listService.currentPageId).children('ul');       
        let element = list.find('li[data-id="' + id + '"]');

        let newIndex = tabIndexDifference + element.index();
        let replacedElement = element.siblings()[newIndex];

        if(replacedElement){       
            element.insertBefore(replacedElement);
        }
        else{
            //IF there is no element in that index add the object to the end of the list
            element.insertAfter(element.siblings().last()); 
        }       

    }

}

const thumbPageListUtil = new ThumbPageListUtil();
export default thumbPageListUtil;
